<template>
    <div class="news">
        <nav-igation class="nav white"></nav-igation>
        <div class="banner"
            :style="{ backgroundImage: `url(${device == 'm' ? require('../../image/m-news.jpg') : require('../../image/news.jpg')})` }">
            <h3> ZHONGYUN NEWS CENTER </h3>
            <p>中云新闻中心</p>
        </div>
        <div class="newsList">
            <div class="item" v-for="(item, index) in newsData" :key="index + 'newsPath'">
                <img :src="item.cover" v-if="device == 'm'" alt="">
                <span>
                    <div class="time">
                        <h3>{{ item.createTime.split('-')[1] }}-{{ item.createTime.split('-')[2] }}</h3>
                        <p>{{ item.createTime.split('-')[0] }}</p>
                    </div>
                    <div class="sork"></div>
                </span>

                <img :src="item.cover" v-if="device != 'm'" alt="">
                <div class="test">
                    <h3>{{ item.name }}</h3>
                    <p>
                        <span>{{ item.introduction }}</span>
                    </p>
                    <div>
                        <p></p>
                        <p @click="$router.push({ path: '/newsInfo', query: { id: item.id } })">查看详情 <img
                                src="@/image/newsIcon.png" alt=""></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="pageSty">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageNum" :page-sizes="[10, 15, 20, 25]" :page-size="pageSize"
                layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
        <div>
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
import { newsList } from '@/api/home.js'
export default {
    data() {
        return {
            newsData: [],
            device: '',
            imgRou: '',//图片引入端 默认pc 

            pageNum:1,
            pageSize:10,
            total:0

        }
    },
    mounted() {
        var vw = window.screen.width
        if (vw <= 1224) {
            this.device = 'ipad'
            this.imgRou = 'i-'
        }
        if (vw <= 750) {
            this.device = 'm'
            this.imgRou = 'm-'
        }
        this.init()
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.init()
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.init()
        },
        init() {
            newsList(`pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(res => {
                this.total = res.total
                res.data.forEach(item => {
                    item.createTime = item.createTime.split(' ')[0]
                });
                this.newsData = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.pageSty{
    width: 80%;
    display: flex;
    justify-content: center;
    margin: 70px auto;
    margin-bottom: 80px;
}
@media screen and (max-width: 750px) {
    #media_weight {
        .banner {
            height: 260px;

            h3 {
                font-size: 19px;
                width: 70%;
                margin-top: 20%;
            }

            p {
                font-size: 30px;
                width: 70%;
                line-height: 20px;
                margin-top: 10px;
            }
        }

        .newsList {
            margin: 0 7%;
            margin-top: 30px;

            .item {
                width: auto;
                display: block;
                padding: 20px;

                >span .sork {
                    margin-top: 28px;
                    margin-left: 10px;
                }

                .time {
                    margin: 0;
                    margin-top: 10px;
                }

                .sork {
                    display: inline;
                }

                >img {
                    width: 100%;
                    margin-right: 0;
                    margin-top: 20px;
                }

                .test {
                    width: 100%;
                    margin-top: 20px;

                    div {
                        margin-top: 20px;
                    }
                }
            }
        }
    }

}

.nav {
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
}

.newsList {
    margin: 0 15%;
    margin-top: 100px;
    margin-bottom: 0;

    .item:hover {
        background: #F2F4F5;
    }

    .item {
        // cursor: pointer;
        margin-bottom: 40px;
        padding: 20px 30px;
        width: 100%;
        // height: 226px;
        border: 1px solid #9797975e;
        display: flex;

        >span {
            display: flex;
        }

        .test {
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;

            h3 {
                font-size: 17px;
                color: #303133;
                font-weight: 800;
            }

            >p {
                font-size: 15px;
                color: #606266;
                line-height: 24px;
                margin-top: 10px;
                flex: 1;

                span {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

            }

            div {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                color: #303133;

                p:nth-child(2) {
                    color: #2EA7E0;
                    cursor: pointer;
                    display: flex;
                    align-items: center;

                    img {
                        width: 13px;
                        height: 12px;
                        margin-left: 3px
                    }

                    ;
                }
            }
        }

        .sork {
            width: 38px;
            height: 1.5px;
            background: #D8D8D8;
            margin-right: 11px;
            margin-top: 50px;
        }

        .time {
            margin-left: 20px;
            margin-right: 30px;
            flex-shrink: 0;
            margin-top: 35px;

            h3 {
                font-size: 28px;
                color: #303133;
                font-weight: 600;
            }

            p {
                font-size: 18px;
                color: #909399;
            }
        }

        >img {
            width: 220px;
            height: auto;
            margin-right: 30px;
        }
    }
}

.banner {
    width: 100%;
    height: 500px;
    background-image: url(../../image/news.jpg);
    background-size: 100% 100%;
    display: flex;
    margin-top: 80px;
    flex-direction: column;

    h3,
    div,
    p {
        margin: 0 auto;
        width: 52%;
        text-align: center;
    }

    h3 {
        font-size: 40px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
        margin-top: 150px
    }

    div {}

    p {
        font-size: 72px;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 94px;
        letter-spacing: 4px;
        margin-top: 18px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/news/index.vue